// extracted by mini-css-extract-plugin
module.exports = {"MenuSectionTitle":"MenuSectionTitle_MenuSectionTitle__2v6Z7","WhiteDash":"MenuSectionTitle_WhiteDash__1dkE-","Title":"MenuSectionTitle_Title__2Ax5i"};